import { connectRefinementList } from "react-instantsearch-dom";
import React from "react";
const RefinementList = ({ items, refine }) => (
	<>
		{items.map((item) => (
			<div className="form-check" key={item.label}>
				<input
					className="form-check-input"
					type="checkbox"
					checked={item.isRefined}
					onChange={() => refine(item.value)}
					id={`jobTypeCheckbox-${item.label}`}
				/>
				<label
					className="form-check-label"
					htmlFor={`jobTypeCheckbox-${item.label}`}
				>
					{item.label}
				</label>
			</div>
		))}
	</>
);

export default connectRefinementList(RefinementList);
